// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__bgeTU","footer":"ReportModalFilter_footer__2S3qr"};